export default __webpack_public_path__ + "static/media/Isf_P_circle.148d1d51.svg";